import React from 'react';

/**
 * Logo component che adatta i colori in base al contesto
 * @param {string} variant - 'primary' per admin (arancione), 'secondary' per user (blu), 'neutral' per altri contesti
 * @param {string} size - dimensione: 'sm', 'md', 'lg', 'xl'
 * @param {string} className - classi CSS aggiuntive
 */
const Logo = ({ variant = 'primary', size = 'md', className = '' }) => {
  // Mapping colori in base alla variante
  const colorClasses = {
    primary: {
      background: 'fill-light-surface dark:fill-dark-surface',
      icon: 'fill-light-primary dark:fill-dark-primary'
    },
    secondary: {
      background: 'fill-light-surface dark:fill-dark-surface',
      icon: 'fill-light-secondary dark:fill-dark-secondary'
    },
    neutral: {
      background: 'fill-light-surface dark:fill-dark-surface',
      icon: 'fill-light-on-surface dark:fill-dark-on-surface'
    }
  };

  // Mapping dimensioni
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24'
  };

  const colors = colorClasses[variant] || colorClasses.primary;
  const sizeClass = sizeClasses[size] || sizeClasses.md;

  return (
    <svg 
      className={`${sizeClass} ${className}`}
      viewBox="0 0 1000 1000" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect 
        className={colors.background}
        width="1000" 
        height="1000" 
        rx="129.94" 
        ry="129.94"
      />
      <path 
        className={colors.icon}
        d="M341.13,212.92c-15.36,22.39-31.4,43.09-44.33,65.58-7.88,13.69-15.86,30.31-15.31,45.3,1.68,45.43,7.5,90.71,11.9,138.11,20.36-2.44,35.74-4.26,51.12-6.14,68.59-8.37,136.96-10.2,204.8,6.26,73.51,17.84,131.73,56.33,168.12,124.27,4.56,8.51,8.15,17.54,10.11,27.59-9.69-11.71-18.96-23.81-29.16-35.07-42.05-46.41-95.47-72.22-155.99-84.57-77.46-15.8-155-9.48-232.41.57-4.98.65-11.6,6.4-13.37,11.27-28.24,77.31-40.71,155.46-12.08,235.94,4.84,13.62,10.9,19.17,26,19.97,119.61,6.31,204.71-46.35,260.75-150.02,5.59-10.33,11.33-20.58,17.06-30.83.26-.46,1.15-.57,3.58-1.69,83.41,40.02,136.08,109.69,175.63,191.97,35.91-54.27,15-236.75-37.94-337.21-74.42-141.22-211.99-219.19-388.49-221.29Z"
      />
    </svg>
  );
};

export default Logo;
